module.exports = __webpack_public_path__ + "static/magic-a0aa89c08f03f3d5055858931e21b5aa.gif";